import React from 'react'
import { css } from '@emotion/core'
import { Paragraph, Separator, LayoutBand, H4 } from '@fs/zion-ui'
import UnavailableImage from '../../../../assets/UnavailableImage'

export default function ErrorPage({ heading, body }) {
  return (
    <LayoutBand maxWidth="sm">
      <div
        data-testid="error-content"
        css={css`
          text-align: center;
        `}
      >
        <UnavailableImage />
        <H4 size="H3" data-testid="error-heading">
          {heading}
        </H4>
        <Separator size="xs" />
        <Paragraph centered>{body}</Paragraph>
        <Separator size="sm" />
      </div>
    </LayoutBand>
  )
}
